import { safeGet } from './safeGet'
import { getDriverValue, getPrimaryScoreResult, isValidNumber } from './driversBubbleChart'

// Data for EfficiencyTestsDetails.vue's "Posizionamento per driver" box plot (DriversBoxPlotChart.vue):
// for each driver of summary.drivers (heaviest first) the distribution of the comparables'
// `driverDetails[].value` (min, Q1, median, Q3, max) and the tested product's own value.

export const POSITION = {
  topQuartile: 'topQuartile',
  aboveMedian: 'aboveMedian',
  belowMedian: 'belowMedian',
  bottomQuartile: 'bottomQuartile',
}

// Linear interpolation between the closest ranks (same as Excel's PERCENTILE.INC). `sorted` ascending.
export function quantile(sorted, p) {
  if (sorted.length === 0) return null
  const pos = (sorted.length - 1) * p
  const lower = Math.floor(pos)
  const upper = Math.ceil(pos)
  return sorted[lower] + (sorted[upper] - sorted[lower]) * (pos - lower)
}

export function getFiveNumberSummary(values) {
  const sorted = [...values].sort((a, b) => a - b)
  if (sorted.length === 0) return null
  return {
    low: sorted[0],
    q1: quantile(sorted, 0.25),
    median: quantile(sorted, 0.5),
    q3: quantile(sorted, 0.75),
    high: sorted[sorted.length - 1],
    count: sorted.length,
  }
}

export function getPosition(value, stats) {
  if (!isValidNumber(value) || !stats) return null
  if (value >= stats.q3) return POSITION.topQuartile
  if (value < stats.q1) return POSITION.bottomQuartile
  return value >= stats.median ? POSITION.aboveMedian : POSITION.belowMedian
}

function driverValueOf(product, driver) {
  return getDriverValue(getPrimaryScoreResult(safeGet(() => product.score, null)), driver)
}

// One row per driver that has at least one scored comparable. Coverage filters never apply here.
export function getDriversBoxPlotRows(drivers, testedProduct, comparables) {
  return [...(drivers || [])]
    .filter((d) => d && d.driver)
    .sort((a, b) => (b.weight || 0) - (a.weight || 0))
    .map((d) => {
      const values = (comparables || []).map((c) => driverValueOf(c, d.driver)).filter(isValidNumber)
      const stats = getFiveNumberSummary(values)
      const tested = testedProduct ? driverValueOf(testedProduct, d.driver) : null
      return {
        driver: d.driver,
        weight: d.weight,
        stats,
        tested: isValidNumber(tested) ? tested : null,
        position: getPosition(tested, stats),
      }
    })
    .filter((row) => row.stats != null)
}
